import "./Contact.css";
import { Helmet } from "react-helmet";
import { FaInstagram } from "react-icons/fa";
import mapsImage from "../assets/images/maps.png";
import { useState } from "react";
import Reservierung from "../components/Reservierung";

const Contact = () => {
  const [consentGiven, setConsentGiven] = useState(false);

  const handleConsent = () => {
    setConsentGiven(true);
  };

  return (
    <>
      <Helmet>
        {/* Basisinformationen */}
        <title>
          Kontakt | Pizzeria 480 Grad – Neapolitanische Pizza in Nürnberg
        </title>
        <meta
          name="description"
          content="So erreichst du die Pizzeria 480 Grad in Nürnberg – Adresse, Anruf-Button, Wegbeschreibung und Instagram-Link. Jetzt Kontakt aufnehmen!"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.480gradpizza.de/contact" />

        {/* Open Graph (Facebook, WhatsApp, LinkedIn) */}
        <meta
          property="og:title"
          content="Pizzeria 480 Grad – Kontakt & Wegbeschreibung"
        />
        <meta
          property="og:description"
          content="Hier findest du Adresse, Telefonnummer, Wegbeschreibung und Social-Media-Link zur Pizzeria 480 Grad in Nürnberg."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.480gradpizza.de/contact" />
        <meta
          property="og:image"
          content="https://www.480gradpizza.de/logo512.png"
        />
        <meta property="og:site_name" content="Pizzeria 480 Grad" />

        {/* Twitter Cards */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Pizzeria 480 Grad – Kontakt aufnehmen"
        />
        <meta
          name="twitter:description"
          content="Kontaktiere uns für Reservierungen oder Fragen – schnell & einfach mit Adresse, Anruf & Karte."
        />
        <meta
          name="twitter:image"
          content="https://www.480gradpizza.de/logo512.png"
        />

        {/* Lokales SEO */}
        <meta name="geo.region" content="DE-BY" />
        <meta name="geo.placename" content="Nürnberg" />
        <meta name="geo.position" content="49.451699;11.069709" />
        <meta name="ICBM" content="49.451699, 11.069709" />
      </Helmet>
      <main className="contact">

        <Reservierung/>

        <section className="address">
          <h1>Adresse</h1>
          <p>
            480Grad neapolitan Pizza X Pianobar
            <br />
            Karl-Grillenberger-Straße 28
            <br />
            90402 Nürnberg
            <br />
          </p>
          <div className="buttoncontainer">
            {" "}
            <a
              href="https://www.instagram.com/480grad/#"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram size={60} />
            </a>
          </div>
        </section>

        <section className="directions">
          <h1>Wegbeschreibung</h1>
          <p>
            Du findest uns ganz einfach: Vom Nürnberger Hauptbahnhof aus mit der
            U-Bahn U1 Richtung Fürth Hardhöhe,
            <br /> an der Haltestelle Weißer Turm aussteigen dann 3-4 Minuten zu
            Fuß.
            <br />
            <br />
            Alternativ kannst du auch mit dem Auto kommen. Parkplätze sind in
            der Nähe verfügbar, zum Beispiel im Parkhaus WÖHRL.
          </p>
          <div className="map-container">
            {!consentGiven ? (
              <div className="map-placeholder" onClick={handleConsent}>
                <img
                  src={mapsImage}
                  alt="Kartenplatzhalter"
                  className="map-image"
                />
                <div className="hover-text">
                  Zum Anzeigen der Karte Cookies von Google Maps akzeptieren
                </div>
              </div>
            ) : (
              <iframe
                title="Google Maps"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2593.7384148694364!2d11.067128477708897!3d49.45166087141878!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479f57eb67ae1e23%3A0x2e07bb454941dbb4!2s480Grad%20neapolitan%20Pizza%20X%20Pianobar!5e0!3m2!1sde!2sde!4v1752832696120!5m2!1sde!2sde"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            )}
          </div>
        </section>
      </main>
    </>
  );
};

export default Contact;
